import { render, staticRenderFns } from "./index.vue?vue&type=template&id=7a86eb90&"
var script = {}


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\project\\文化宫\\code\\whg\\Web\\Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7a86eb90')) {
      api.createRecord('7a86eb90', component.options)
    } else {
      api.reload('7a86eb90', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=7a86eb90&", function () {
      api.rerender('7a86eb90', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/PMS/estateManagement/notice/index.vue"
export default component.exports